<mat-card>Affecter Json</mat-card>
<form [formGroup]="form" (submit)="isertJson()">
    <json-editor [options]="editorOptions" formControlName="contentJson"> </json-editor>
    <br />
    <div fxLayout="row">
        <button mat-flat-button color="primary">Ajouter</button>
    </div>
</form>
